var ExperimentStatus = /* @__PURE__ */ ((ExperimentStatus2) => {
  ExperimentStatus2["NotStarted"] = "Not started";
  ExperimentStatus2["Running"] = "Running";
  ExperimentStatus2["Stopped"] = "Stopped";
  return ExperimentStatus2;
})(ExperimentStatus || {});
export {
  ExperimentStatus
};
//# sourceMappingURL=AudienceStageModels.js.map
